import { createContext } from "react";

export const ServiceAcceptanceModalContext = createContext();
